// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"d6090798","877":"b1d88dda"}[chunkId] + ".chunk.js";
};